import Dexie, { Table } from 'dexie'
import type { AllEvents } from 'modules/analytics/core'

export type EventRow = AllEvents & {
  id: string
  projectID: string
  country?: string
}

export class ClientDatabase extends Dexie {
  events: Table<EventRow, number>

  constructor() {
    super('chiffre')
    this.version(1).stores({
      events: '&id,projectID,type,time'
    })
    this.events = this.table('events')
  }
}

export async function createClientDatabaseInstance() {
  const instance = new ClientDatabase()
  await instance.open()
  return instance
}

// --

export interface ExportArgs {
  projectID: string
  from?: number
  to?: number
}

export async function exportProjectDatabase(
  db: ClientDatabase,
  { projectID, from = 0, to = Date.now() }: ExportArgs
) {
  const formatDate = (timestamp: number) =>
    new Date(timestamp).toISOString().replace(/:/g, '-')
  const fileName = `chiffre-export-${projectID}-${formatDate(
    from
  )}-${formatDate(to)}.ndjson`

  const events = await db.events
    .where('time')
    .between(from, to, true, false)
    .and(event => event.projectID === projectID)
    .toArray()

  downloadTextFile(
    events.map(event => JSON.stringify(event)).join('\n'),
    fileName
  )
}

function downloadTextFile(text: string, fileName: string) {
  const blob = new Blob([text], { type: 'text/plain' })
  const a = document.createElement('a')
  const mouseEvent = document.createEvent('MouseEvents')
  a.download = fileName
  a.href = window.URL.createObjectURL(blob)
  a.dataset.downloadurl = ['text/plain', a.download, a.href].join(':')
  mouseEvent.initEvent('click', true, false)
  a.dispatchEvent(mouseEvent)
}
